export class Quotes {
    static allQuotes = [
        "Hey, Every morning is a new canvas—paint it with purpose, passion, and positivity.", 
        "Welcome back! Today is full of possibilities and opportunities.",
        "Success is not final, failure is not fatal: it is the courage to continue that counts.",
        "The only way to do great work is to love what you do.",
        "Your potential is limitless. Let's make today amazing!",
        "Small steps lead to big achievements. Keep going!",
        "Today's efforts are tomorrow's successes.",
        "Make today ridiculously amazing!",
        "Your journey to success starts with a single step.",
        "Believe in yourself and all that you are capable of.",
        "Every day is a fresh start to create something beautiful.",
        "Your positive energy is contagious—spread it everywhere!",
        "The best way to predict the future is to create it.",
        "Dream big, work hard, stay focused, and surround yourself with good people.",
        "Your attitude determines your direction.",
        "Make today so awesome that yesterday gets jealous.",
        "The only limit to your impact is your imagination and commitment.",
        "You are stronger than you think and more capable than you know.",
        "Today is your opportunity to build the tomorrow you want.",
        "Your potential is like a seed—water it with effort and watch it grow.",
        "Every moment is a fresh beginning.",
        "Your smile is your superpower—use it often!",
        "The road to success is always under construction.",
        "You are the author of your own story—make it a bestseller.",
        "Your energy introduces you before you even speak.",
        "Today's small progress is tomorrow's big achievement.",
        "Your positive mindset is your greatest asset.",
        "Make today ridiculously productive and amazingly fun!",
        "Your determination today shapes your destiny tomorrow.",
        "Every challenge is an opportunity in disguise.",
        "Your enthusiasm is the spark that ignites success.",
        "Today's preparation determines tomorrow's achievement.",
        "Your creativity knows no bounds—let it flow!",
        "The best time to start was yesterday, the second best time is now.",
        "Your potential is like a muscle—it grows with use.",
        "Make today so productive that yesterday gets jealous.",
        "Your positive attitude is your greatest strength.",
        "Every day is a chance to be better than yesterday.",
        "Your journey is unique—embrace it fully.",
        "Today's effort is tomorrow's success story.",
        "Your smile can change the world—start with your own.",
        "The only way to do great work is to love what you do.",
        "Your determination today shapes your success tomorrow.",
        "Every moment is a fresh opportunity to shine.",
        "True teamwork happens best when people are humble.",
        "Your positive energy is your greatest gift.",
        "Today's small steps lead to tomorrow's giant leaps.",
        "Your potential is like a diamond—it just needs polishing.",
        "Make today so amazing that tomorrow can't wait to begin.",
        "Your attitude is the paintbrush of your life's canvas.",
        "Every day is a new chapter in your success story.",
        "Your enthusiasm is the key to unlocking your potential.",
        "Success is a journey, not a destination. Enjoy the ride!",
        "Your potential is like a garden—nurture it daily.",
        "Today's challenges are tomorrow's strengths.",
        "Your positive mindset is your greatest superpower.",
        "Every step forward is a victory worth celebrating.",
        "Your determination today shapes your legacy tomorrow.",
        "Make today so productive that yesterday gets inspired.",
        "Your creativity is the spark that ignites innovation.",
        "The best version of yourself is waiting to be discovered.",
        "Your energy is contagious—spread positivity everywhere.",
        "Today's small progress is tomorrow's giant leap.",
        "Every moment is a chance to create something amazing.",
        "Your smile can brighten someone's entire day.",
        "The road to success is paved with daily progress.",
        "Your attitude determines your altitude.",
        "Make today so awesome that tomorrow can't wait.",
        "Your journey is unique—embrace every step.",
        "Today's preparation determines tomorrow's success.",
        "Your positive energy is your greatest asset.",
        "Your determination is stronger than any obstacle.",
        "The best time to start is now—don't wait.",
        "Your potential is limitless—believe in yourself.",
        "Make today so productive that yesterday gets jealous.",
        "Your creativity knows no bounds—let it flow.",
        "Every challenge is an opportunity in disguise.",
        "Your enthusiasm is the spark that ignites success.",
        "Today's effort is tomorrow's achievement.",
        "Your positive mindset is your greatest strength.",
        "Every step forward is progress worth celebrating.",
        "Your potential is like a diamond—it just needs polishing.",
        "Make today so amazing that yesterday gets inspired.",
        "Your journey is your story—make it epic.",
        "Today's small steps lead to tomorrow's giant leaps.",
        "Your energy introduces you before you even speak.",
        "Every moment is a chance to shine brighter.",
        "Your determination today shapes your success tomorrow.",
        "The best way to predict the future is to create it.",
        "Your potential is like a muscle—it grows with use.",
        "Make today so productive that tomorrow thanks you.",
        "Your creativity is the key to unlocking possibilities.",
        "Every day is a new opportunity to be extraordinary.",
        "Your positive attitude is your greatest gift.",
        "Today's preparation is tomorrow's success story.",
        "Your enthusiasm is contagious—spread it everywhere.",
        "Every challenge is a chance to grow stronger.",
        "Your potential is like a garden—nurture it daily.",
        "Today's effort is tomorrow's success.",
        "Your smile is your superpower—use it often!",
        "The road to success is always under construction.",
        "Your potential is like a seed—water it with effort.",
        "Every moment is a chance to create something amazing.",
        "Your smile can brighten someone's entire day.",
        "The road to success is paved with daily progress.",
        "Your attitude determines your altitude.",
        "Make today so awesome that tomorrow can't wait.",
        "Your journey is unique—embrace every step.",
        "Today's preparation determines tomorrow's success.",
        "Your positive energy is your greatest asset.",
        "A humble mind learns more than a proud one ever will.",
        "Don’t let pride silence your progress.",
        "Working together means growing together.",
        "Collaboration thrives when humility leads the way.",
        "Together, we can achieve greatness.",
        
      ];
}